'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = HR;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _AbstractElement = require('./AbstractElement');

var _AbstractElement2 = _interopRequireDefault(_AbstractElement);

var _DistanceConstants = require('../layout/DistanceConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getClasses = function getClasses(className, distance) {
  return (0, _reactUtils.classNames)('private-hr', className, _DistanceConstants.DISTANCE_CLASSES[distance]);
};

function HR(_ref) {
  var className = _ref.className,
      distance = _ref.distance,
      rest = _objectWithoutProperties(_ref, ['className', 'distance']);

  return _react2.default.createElement(_AbstractElement2.default, _extends({}, rest, {
    className: getClasses(className, distance),
    tagName: 'hr'
  }));
}

HR.propTypes = {
  className: _react.PropTypes.string,
  distance: _react.PropTypes.oneOf(Object.keys(_DistanceConstants.DISTANCE_CLASSES)).isRequired
};

HR.defaultProps = {
  distance: 'medium'
};

HR.displayName = 'HR';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/elements/HR.js
// module id = 238
// module chunks = 0 1